// extracted by mini-css-extract-plugin
export default {"block":"styles_block__Vi0yE","upperImage":"styles_upperImage__SVKlZ"};